const SODEXO = 'SODEXO';
const CLIENT = 'CLIENT';

export const distributionType = {
  SODEXO,
  CLIENT,
};
